const FREE_SHIPPING_THRESHOLDS = {
  'NO': { amount: 400, currency: 'NOK' },
  'DK': { amount: 224, currency: 'DKK' },
  // GB is listed explicitly so the pound market gets 39.85 exactly. Without an entry it
  // falls through to the default and is multiplied by the currency rate, which would
  // produce a rounded off figure that no longer matches the product page copy.
  'GB': { amount: 39.85, currency: 'GBP' },
  // Default fallback for other countries (EUR-based)
  'default': { amount: 39.85, currency: 'EUR' }
};

if (typeof window !== 'undefined') {
  window.FREE_SHIPPING_THRESHOLDS = FREE_SHIPPING_THRESHOLDS;
}